import { removeNullableProperties } from '@/shared/lib/removeNullableProperties';
import { trackEvent } from '@/entities/sogu';
import { useTourFiltersTotalCount } from '@/entities/filter/store/composables/tour/TourUseFiltersTotalCount';
import { tourMapFilterDataToSogu, useTourFiltersStore } from '@/entities/filter/store/tour';
import type { CityInfo, CountryInfo, RegionInfo } from '@/shared/api/experience';
import type { ContextGeoSubject } from '@/shared/types/geography';

function pickTotalExperiences(geo: CityInfo | CountryInfo | RegionInfo): number {
  return geo.tours_count ?? 0;
}

export function useTourPageViewTracker() {
  const filterStore = useTourFiltersStore();
  const { totalCount } = useTourFiltersTotalCount(filterStore.state, filterStore.pageParams);

  const trackListingPageViewEvent = async (
    tagId: number | null,
    geoInfo: CityInfo | CountryInfo | RegionInfo,
    defaultSoguFields: ContextGeoSubject,
    currency?: string,
  ) => {
    const payload = removeNullableProperties({
      tag_id: tagId,
      total_experiences: pickTotalExperiences(geoInfo),
      filtered_experiences: totalCount.value,
      currency,
      ...tourMapFilterDataToSogu(filterStore.state),
    });

    return trackEvent('listing.pageview', { ...defaultSoguFields.soguStamp, ...payload });
  };

  return {
    trackListingPageViewEvent,
  };
}
